import zod from 'zod';
import { IntegrationFormSchema } from '../../IntegrationService/schemas';

export const DefenseBridgeConfigSchema = zod
  .object({
    id: zod.number().optional(),

    serverIp: zod
      .string()
      .nonempty('O IP do servidor é obrigatório.')
      .regex(
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
        'O IP do servidor deve ser um endereço IP válido.',
      ),

    serverPort: zod
      .number({ required_error: 'A porta do servidor é obrigatória.' })
      .int('A porta do servidor deve ser um número inteiro.')
      .min(1, 'A porta do servidor deve ser maior que 0.')
      .max(65535, 'A porta do servidor deve ser menor ou igual a 65535.'),

    accessKey: zod.string().nonempty('A chave de acesso é obrigatória.'),

    secretKey: zod.string().nonempty('A chave secreta é obrigatória.'),
  })
  .merge(IntegrationFormSchema);
